import Sixt from "images/sixt.png";
import Demokratene from "images/demokratene.png";
import Frydenbo from "images/frydenbo.png";
import Hamre from "images/hamre.png";
import Techhype from "images/techhype.png";
import Vipps from "images/vipps_logo.png";

export const clientsData = [
  {
    label: "Sixt",
    image: Sixt,
  },
  {
    label: "Demokratene",
    image: Demokratene,
  },
  {
    label: "Frydenbø",
    image: Frydenbo,
  },
  {
    label: "Hamre",
    image: Hamre,
  },
  {
    label: "Techhype",
    image: Techhype,
  },
  {
    label: "Vipps",
    image: Vipps,
  },
];
